import React from 'react';
import {
    Box,
    Button,
    Container,
    Grid,
    Typography,
    useTheme,
    useMediaQuery,
    Card,
    CardContent,
    Divider,
    IconButton,
    Tooltip,
    Paper
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import ConferenceNavbar from "../frontend/Conference/ConferenceNavbar";

import { useDeadline } from "../contexts/DeadlineContext";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const SpeakerThankYouPage = () => {
    const { abstractHomeSetup } = useDeadline();
    const location = useLocation();
    const participantId = location.pathname.split("/").pop();
    const badgeUrl = location.state?.badge_url;
   
    const primaryColor = abstractHomeSetup.color_code_two || '#05597D';
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // Function to copy text to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };



    return (
        <Box display="flex" flexDirection="column" minHeight="100vh" bgcolor="#f5f7fa">
            {/* <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid> */}

            {/* Top-right Back Button */}
            <Box display="flex" justifyContent="flex-end" alignItems="center" p={2}>
                <Button
                    component={Link}
                    to="/speaker-registration-form"
                    variant="contained"
                    size="small"
                    sx={{
                        backgroundColor: primaryColor,
                        '&:hover': {
                            backgroundColor: primaryColor,
                            opacity: 0.9,
                        },
                    }}
                >
                    Back to Verification
                </Button>
            </Box>

            {/* Main Content */}
            <Container maxWidth="md" sx={{ py: 4, flexGrow: 1 }}>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3, mb: 4 }}>
                    <Typography 
                        variant={isSmallScreen ? 'h5' : 'h4'} 
                        gutterBottom 
                        align="center"
                        sx={{ 
                            color: primaryColor,
                            fontWeight: 'bold',
                            mb: 3
                        }}
                    >
                        🎉 Thank You for Registering!
                    </Typography>
                    
                    <Box textAlign="center" mb={4}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Your registration has been successfully completed.
                        </Typography>
                        <Typography variant="body1">
                            <strong>QR Code ID:</strong> {participantId}
                        </Typography>
                    </Box>

              

                    {badgeUrl && (
                        <Box textAlign="center" mt={4}>
                            <Button
                                variant="contained"
                                href={badgeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    px: 4,
                                    py: 1.5,
                                    color: '#fff',
                                    backgroundColor: primaryColor,
                                    fontWeight: 'bold',
                                    '&:hover': {
                                        backgroundColor: primaryColor,
                                        opacity: 0.9,
                                    },
                                }}
                            >
                                View Your Conference Badge
                            </Button>
                        </Box>
                    )}

                    <Box mt={4} textAlign="center">
                        <Typography variant="body1" sx={{ mb: 2, fontStyle: 'italic' }}>
                            📧 A confirmation email has been sent to your registered email address.
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            If you don't see it in your inbox, please check your spam or junk folder.
                        </Typography>
                    </Box>
                </Paper>
            </Container>

            {/* Footer */}
            {/* <Grid item xs={12} sm={10} md={8} lg={6} sx={{ mt: 'auto' }}>
                <NewVersionAbstractFooter />
            </Grid> */}
        </Box>
    );
};


export default SpeakerThankYouPage;
